import React from "react";
import LineCreator from "./LineCreator";

const LineGenerator = ({ index, roundsList, matches }) => {
  return roundsList[0].rounds == 128 ? (
    <>
      {matches.length == 64 && (
        <LineCreator
          index={index}
          divider2Style="19px"
          divider2Height="40px"
          divider3Style="75%"
        />
      )}
      {matches.length == 32 && (
        <LineCreator
          index={index}
          divider2Height="79px"
          divider2Style="58px"
          divider3Style="132%"
        />
      )}
      {matches.length == 16 && (
        <LineCreator
          index={index}
          divider2Height="157px"
          divider2Style="137px"
          divider3Style="235%"
        />
      )}

      {matches.length == 8 && (
        <LineCreator
          index={index}
          divider2Height="625px"
          divider2Style="605px"
          divider3Style="465%"
        />
      )}

      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Height="1250px"
          divider2Style="1230px"
          divider3Style="910%"
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="2495px"
          divider2Style="2475px"
          divider3Style="1800%"
        />
      )}

      {matches.length == 1 && (
        <LineCreator
          index={index}
          divider2Height="2495px"
          divider2Style="2475px"
          divider3Style="3585%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 64 ? (
    <>
      {matches.length == 32 && (
        <LineCreator
          index={index}
          divider2Style="19px"
          divider2Height="40px"
          divider3Style="75%"
        />
      )}

      {matches.length == 16 && (
        <LineCreator
          index={index}
          divider2Height="157px"
          divider2Style="136px"
          divider3Style="135%"
        />
      )}

      {matches.length == 8 && (
        <LineCreator
          index={index}
          divider2Height="157px"
          divider2Style="136px"
          divider3Style="240%"
        />
      )}

      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Height="315px"
          divider2Style="295px"
          divider3Style="465%"
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="625px"
          divider2Style="605px"
          divider3Style="910%"
        />
      )}

      {matches.length == 1 && (
        <LineCreator
          index={index}
          divider2Height="1250px"
          divider2Style="1230px"
          divider3Style="1800%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 32 ? (
    <>
      {matches.length == 16 && (
        <LineCreator
          index={index}
          divider2Style="19px"
          divider2Height="40px"
          divider3Style="75%"
        />
      )}

      {matches.length == 8 && (
        <LineCreator
          index={index}
          divider2Height="79px"
          divider2Style="58px"
          divider3Style="125%"
        />
      )}

      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Height="157px"
          divider2Style="136px"
          divider3Style="240%"
          divider2Padding={0.15}
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="313px"
          divider2Style="292px"
          divider2Padding={0.15}
          divider3Style="450%"
        />
      )}

      {matches.length == 1 && (
        <LineCreator
          index={index}
          divider2Height="625px"
          divider2Style="605px"
          divider2Padding={0.15}
          divider3Style="910%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 16 ? (
    <>
      {matches.length == 8 && (
        <LineCreator
          index={index}
          divider2Style="19px"
          divider2Height="40px"
          divider3Style="75%"
        />
      )}

      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Height="157px"
          divider2Style="136px"
          divider3Style="135%"
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="313px"
          divider2Style="292px"
          divider3Style="245%"
        />
      )}

      {matches.length == 1 && (
        <LineCreator
          index={index}
          divider2Height="313px"
          divider2Style="292px"
          divider3Style="465%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 8 ? (
    <>
      {matches.length == 4 && (
        <LineCreator
          index={index}
          divider2Style="19px"
          divider2Height="40px"
          divider3Style="75%"
        />
      )}

      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Height="79px"
          divider2Style="58px"
          divider3Style="125%"
        />
      )}

      {matches.length < 2 && (
        <LineCreator
          index={index}
          divider2Height="157px"
          divider2Style="137px"
          divider3Style="240%"
        />
      )}
    </>
  ) : roundsList[0].rounds == 4 ? (
    <>
      {matches.length == 2 && (
        <LineCreator
          index={index}
          divider2Style="19px"
          divider2Height="40px"
          divider3Style="75%"
        />
      )}

      {matches.length < 2 && (
        <LineCreator
          index={index}
          divider2Height="79px"
          divider2Style="58px"
          divider3Style="125%"
        />
      )}
    </>
  ) : null;
};

export default LineGenerator;
